module.exports = __webpack_public_path__ + "img/zhuanpan-zhizhen-gray.3a742374.png";